module.exports = __webpack_public_path__ + "img/Capture15.4af0811a.jpg";